module.exports = __webpack_public_path__ + "img/graphic-poor-result-sad-guy.acf61955.svg";